import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { ContainedButton } from 'secondstep-components'

import {
  ModalHeaderInput,
  CancelButton,
  ModalWrapperInput,
} from '../../component.styles'

import {
  DeleteCheckBox as BaseCheckBox,
  DeleteMessageWrapper as BaseMessageWrapper,
  DeleteWarningSpan as BaseWarningSpan,
  StyledButtonsWrapper as BaseButtonsWrapper,
} from '../Delete/component.styles'

export const HideMessageWrapper = BaseMessageWrapper

export const HideWarningSpan = BaseWarningSpan

export const ModalWrapperHide = styled(ModalWrapperInput).attrs(() => ({
  size: 'small',
}))`
  padding: 2.3125rem 2.5rem 2.125rem 2.5rem;

  ${CancelButton} {
    background: none;
    margin: 0.5rem 0.875rem 0.4375rem 0.125rem !important;
    max-width: 9.375rem;
    padding: 0.5rem 1.25rem 0.3125rem 1.25rem;
    width: 50%;

    @media screen and (max-width: 398px) {
      margin-top: 0.5rem;
      padding: 0.5rem 0 0.5rem 0;
    }

    ${themeGet('breakpoints.mobile')} {
      margin-bottom: 0 !important;
      margin-right: 0.625rem !important;
    }
  }

  ${ModalHeaderInput} {
    color: ${themeGet('colors.secondStepBlue')};
    font-family: ${themeGet('font.sharpSlab.semibold')};
    font-size: 1.625rem;
    justify-content: center;
    margin-bottom: 0.75rem;
    text-align: center;

    ${themeGet('breakpoints.mobile')} {
      margin-bottom: 1rem;
    }
  }

  ${themeGet('breakpoints.mobile')} {
    padding: 2.3125rem 1.25rem 2.5rem 1.25rem;
  }
`

export const HideCheckBox = BaseCheckBox

export const HideButtonsWrapper = styled(BaseButtonsWrapper)`
  position: relative;
  bottom: 0;
  left: 0;
  justify-content: center;
  margin: 0;
  transform: none;
  width: 100%;

  ${themeGet('breakpoints.mobile')} {
    left: 0;
  }
`

export const HideButton = styled(ContainedButton)`
  background: ${props =>
    props.isDisabled
      ? themeGet('colors.gray650')(props)
      : themeGet('colors.buttons.primary.bgActive')(props)} !important;
  border: none;
  margin: 0.5rem 0.0625rem 0.4375rem 0.125rem;
  max-width: 11.25rem;
  opacity: 1;
  padding: 0.5rem 0 0.3125rem 0;
  width: 50%;

  @media screen and (max-width: 398px) {
    margin-top: 0.5rem;
    padding: 0.5rem 0 0.5rem 0;
  }

  ${themeGet('breakpoints.mobile')} {
    margin-bottom: 0;
  }
`
